<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage">
<a id="title61"></a>
<div class="verse"><span><em class="i"><strong class="b">As for the poem, one dragon, however hot, does not make a summer, or a host; and a man might well exchange for one good dragon what he would not sell for a wilderness. And dragons, real dragons, essential both to the machinery and the ideas of a poem or tale, are actually rare.</strong></em></span></div>
<div class="source"><span>—J. R. R. TOLKIEN,<br/> “Beowulf: The Monsters and the Critics”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="verse"><span><em class="i"><strong class="b">He is at once a stratum of the earth and a streamer in the air, no painted dragon but a figure of real oneiric power, one that can easily survive the prejudices which arise at the very mention of the word “dragon.”</strong></em></span></div>
<div class="source"><span>—SEAMUS HEANEY,<br/> <em class="i">Introduction to his translation of</em> Beowulf</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429949880_epi01.vue?1ef049ec